import request from '@/utils/request'

export function fetchList(params) {
    return request({
        url: '/currency/list/',
        method: 'get',
        params: params
    })
}
export function deleteCurrency(id) {
    return request({
        url: '/currency/delete/' + id,
        method: 'post'
    })
}

export function createCurrency(data) {
    return request({
        url: '/currency/create',
        method: 'post',
        data: data
    })
}


export function updateCurrency(id,data) {
    return request({
        url: '/currency/update/' + id,
        method: 'post',
        data: data
    })
}


export function getHistoryList(params,code) {
    return request({
      url:'/currency/history/' + code,
      method:'get',
      params:params
    })
  }
  

export function getLatestList() {
    return request({
        url: '/currency/latestList/',
        method: 'get',
    })
}

export function getCurrencyLatestList() {
    return request({
        url: '/currency/currencyLatestList/',
        method: 'get',
    })
}


export function getCurrencyByCode(code) {
    return request({
        url: '/currency/latest/' + code,
        method: 'get',
    })
}

// Starts an async bulk price recalculation job and returns its job id (CommonResult<String>).
// The recalculation itself runs in the background on the server — poll getCalculatedPriceJobStatus
// with the returned job id to find out when it finishes.
export function startCalculatedPriceJob() {
    return request({
        url: '/currency/calculateAll',
        method: 'post',
    })
}

export function getCalculatedPriceJobStatus(jobId) {
    return request({
        url: '/currency/calculateAll/status/' + jobId,
        method: 'get',
    })
}
